// components/EmployeePerformanceDashboard.jsx
import React, { useEffect, useState } from "react";

import EmployeeKPICards from "./EmployeeKPICard";
import EmployeeKPIChart from "./Employeedashboard";
import EmployeeHoursTrendChart from "./Employeehourschart";

export default function EmployeePerformanceDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 const restaurantId = sessionStorage?.getItem("store_id") || "Null";
  useEffect(() => {
    const fetchPerformanceData = async () => {
      try {
        const res = await fetch(
          `/server/dashboard-functions/employee/${restaurantId}`
        );
        const json = await res.json();
        if (json.success) {
          setData(json.data);
        } else {
          setError(json.message || "Failed to load data");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPerformanceData();
  }, []);

 const Loader = () => (
    <div className="flex justify-center items-center h-full min-h-[300px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-[#E57320] border-solid"></div>
    </div>
);
 
  if (loading) return <Loader />;

  if (error) {
    return <p className="text-center text-red-500">Error: {error}</p>;
  }

  if (!data) {
    return <p className="text-center">No data available</p>;
  }

  return (
    <section className="w-full">

      <p className="mb-6">
        <span className="text-2xl font-semibold text-gray-800">
          Employee Performance Details
        </span>
      </p>
      {/* KPI Cards on top */}
      <EmployeeKPICards dataset={data.dataset1} />

      {/* Two charts side-by-side on md+, stacked on mobile */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-2xl shadow">
          <EmployeeHoursTrendChart dataset={data.dataset2} />
        </div>

        <div className="bg-white p-6 rounded-2xl shadow">
          <EmployeeKPIChart dataset={data.dataset3} />
        </div>
      </div>
    </section>
  );
}
